import React, { useState, Component } from 'react';
import axios from 'axios';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';

import { BaseUrl } from '../common/config';
import Loader from '../common/loader';
import ChangePassword from "./Changepassword"

class Myaccount extends Component {

  constructor(props) {
    super(props);
    this.state = {
      passwordPopup: false,
      alertmessage: false,
      errorPopup:false,
    };

    if (!localStorage.getItem("isLoggedIn"))
        window.location.href = '/';

  }

  componentDidMount() {
    var alertMessage = localStorage.getItem('change_password');
    if(alertMessage === '1'){
      this.setState({alertmessage:true});
    } 
    
    var current = this;
    const myTimeout =  setInterval(function(){
      current.setState({alertmessage:false, errorPopup:false}); 
      localStorage.removeItem('change_password', '');
       clearTimeout(myTimeout);
    },8000);

    

  }

   componentDidUpdate() {
    
  }


  changePassword(e){

    e.preventDefault();

    this.setState({passwordPopup: true, errorPopup:false});

    localStorage.setItem('change_password', '');

  }

    popupClose(){

       var elems = document.getElementsByClassName('change-password-popup');
        for (var i=0;i<elems.length;i+=1){
          elems[i].style.display = 'none';
        }
    }

    alertFunction(){
      return (
            <div className='alert-section'>
                    <p className='success'>You successfully changed your account password!</p>
                    {/*<p className='error'>Sorry! Password not Updated</p>*/}
          </div>
        );
    }


     errorpopupClose(){
        this.setState({
            errorPopup: false, 
        });

      }


  render() {

    var authData = JSON.parse(localStorage.getItem('authData'));

    var Changepassword = localStorage.getItem('change_password');

    return (
      <>
        <Header />
          <section className="my-acc-block">
            <div className="sm-container">
            
              <div className="acc-ttflx">
                <h1 className="checkout-title"></h1>
                  <div className='header-tab-menu'>
                    <a href='/account'>My Orders</a>
                    <a className='active' href='/myaccount'>My Account</a>
                  </div>
                  <a href='/home' className="acc-back"><i className="fa fa-arrow-left"></i> Back To Main</a>
              </div>

              <div className='myact-wrap'>
                  
              {this.state.alertmessage === true && this.alertFunction()}

                <div className='client-details'>
                    <div className='my-acc-hdr-wrap'>
                      <h3>Account Details</h3>
                    </div>
                    <div className='client-detail-bx'>
                        <form className='client-detail-form'>
                            <div className='form-field'>
                                <label htmlFor='name'>Name</label>
                                <input type="text" defaultValue={authData.accountName} readOnly />
                                <a className="edit-opt"><i className="fa fa-pencil-square-o"></i> Edit</a>
                            </div>
                            <div className='form-field'>
                                <label htmlFor='accountcode'>Account Code</label>
                                <input type="text" defaultValue={authData.accountCode} readOnly />
                            </div>
                            <div className='form-field'>
                                <label htmlFor='accountemail'>Email Address</label>
                                <input type="text" defaultValue={authData.accountEmail} readOnly />
                            </div>
                            {/*<div className='form-field'>
                                <input type="text" value="Telephone Number" readOnly />
                                <a className="edit-opt"><i className="fa fa-pencil-square-o"></i> Edit</a>
                            </div>*/}
                            <div className='form-field'>
                                <label htmlFor='accountemail'>Address</label>
                                <textarea type="text" defaultValue={(authData.accountAddress1 !== undefined ? authData.accountAddress1 + ", ": "") + ""  + (authData.accountAddress2 !== undefined ? authData.accountAddress2 + ", " : "") + "" + (authData.accountAddress3 !== undefined ? authData.accountAddress3 + ", " : "")+ "" + (authData.accountAddress4 !== undefined ? authData.accountAddress4 + ", ": "") + "" + (authData.accountAddress5 !== undefined ? authData.accountAddress5 : "")} readOnly></textarea>
                                <a className="edit-opt"><i className="fa fa-pencil-square-o"></i> Edit</a>
                            </div>
                            
                        </form>
                    </div>
                </div>

                <div className='client-details'>
                  <div className='client-detail-bx'>
                      <form className='client-detail-form pwd-change-form'>
                        <div className='form-field'>
                            <label>Password</label>
                            <div className='pass-input'>********</div>
                        </div>
                        <button className='button' onClick={this.changePassword.bind(this)}> Edit</button>
                      </form>
                    </div>
                </div>


              </div>
            </div>
          </section>
          {this.state.passwordPopup === true && 

          <ChangePassword close={this.popupClose.bind(this)}  show ="open"/>
          }


          {this.state.errorPopup === true && 
                  <div className='custom-alert-pop common_alert_popup'>
                    <div className='custom-alert-container'>
                        <div className='custom-alert-wrap'>
                            <div className='custom-alert-header'>
                                <h4>Alert</h4>
                            </div>
                            <div className='custom-alert-body'>
                                <p>For demonstration purposes we have disabled the change password option!</p>

                                <div className='alert-buttons'>
                                    <a className="popup-alert-btn button" onClick={this.errorpopupClose.bind(this)}>Ok</a>
                                 </div>
                            </div>
                        </div>
                    </div>
                </div>
              }


        <Footer />
      </>
    )
  }
}

export default Myaccount;